import React from 'react'
import { Typography, ListItem, ListItemAvatar, Avatar, Box } from '@material-ui/core'
import PropTypes from 'prop-types'

export default function ContributionListItem({ encodedBankLogo, primaryText, transactionName, accountName, contribution }) {
  return (
    <ListItem disableGutters>
      <ListItemAvatar>
        <Avatar src={`data:image/png;base64, ${encodedBankLogo}`} />
      </ListItemAvatar>

      <Box width='60%'>
        <Typography variant='subtitle2'>{primaryText}</Typography>
        <Typography variant='body2' noWrap>
          {accountName}
          <br />
          {transactionName}
        </Typography>
      </Box>
      <Box width='40%'>
        <Typography align='right' variant='subtitle1' color='secondary'>{contribution}</Typography>
      </Box>
    </ListItem>    
  )
}

ContributionListItem.propTypes = {
  encodedBankLogo: PropTypes.string.isRequired,
  primaryText: PropTypes.string.isRequired,
  transactionName: PropTypes.string.isRequired,
  accountName: PropTypes.string.isRequired,
  contribution: PropTypes.string.isRequired
}
